if (!window.customElements.get("country-switcher")) {
    class CountrySwitcher extends HTMLElement {
        sectionElement: HTMLElement;
        headerElement: HTMLElement;

        connectedCallback(): void {
            this.sectionElement = this.closest(".shopify-section");
            this.headerElement = document.getElementById("main-header");

            // set actual working data-country on section level
            this.sectionElement.dataset.returnsCountry =
                this.dataset.returnsCountry;
            // remove it from current element -- it worked for this section before JS load
            this.dataset.returnsCountry = null;

            this.addEventListener("click", this._handleClick.bind(this));

            window.addEventListener("scroll", this._handleScroll.bind(this));
            window.addEventListener("resize", this._handleScroll.bind(this));

            // check where we are on the page initially -- can be not at the top
            this._handleScroll();
        }

        _handleClick(event) {
            const button = event.target;
            if (button.tagName !== "BUTTON") return;
            const { returnsCountry } = button.dataset;
            if (this.sectionElement.dataset.country !== returnsCountry) {
                this.sectionElement.dataset.returnsCountry = returnsCountry;
                if (this.classList.contains("sticky")) {
                    this.parentElement.scrollIntoView({ behavior: "smooth" });
                }
            }
        }

        _handleScroll() {
            const headerRect: DOMRect =
                this.headerElement.getBoundingClientRect();
            const thisRect: DOMRect = this.getBoundingClientRect();
            const parentRect: DOMRect =
                this.parentElement.getBoundingClientRect();

            if (this.classList.contains("unsticking")) {
                if (
                    thisRect.top < headerRect.bottom &&
                    thisRect.bottom > headerRect.bottom
                )
                    // gray zone -- bottom line of the header crosses our element,
                    // do not make decisions while this is the case.
                    // prevents from jumps/stutters because our element gets taller during unsticking, this may affect logic
                    return;
                else this.classList.remove("unsticking");
            }

            if (!this.classList.contains("sticky")) {
                if (thisRect.bottom > headerRect.bottom) return;
                // to avoid jumps:
                //  sticking on bottom because sticky element changes height
                //  setting height on parent element to compensate for sticky element "removal"
                this.parentElement.style.height = `${thisRect.height}px`;
                this.classList.add("sticky");
                this.classList.remove("lg:tw-max-w-[1440px]");
                this.style.top = `${headerRect.bottom}px`;
            } else if (parentRect.bottom > thisRect.bottom) {
                this.parentElement.style.height = ``;
                this.classList.add("unsticking");
                this.classList.remove("sticky");
                this.classList.add("lg:tw-max-w-[1440px]");
                this.style.top = "";
            }
        }
    }

    window.customElements.define("country-switcher", CountrySwitcher);
}
